// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Array_NonEmpty from "../Data.Array.NonEmpty/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Either_Extra from "../Data.Either.Extra/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_HeytingAlgebra from "../Data.HeytingAlgebra/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Monoid_Extra from "../Data.Monoid.Extra/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Semiring from "../Data.Semiring/index.js";
import * as Data_Set from "../Data.Set/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_String_CodePoints from "../Data.String.CodePoints/index.js";
import * as Data_String_CodeUnits from "../Data.String.CodeUnits/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
import * as Data_String_Regex from "../Data.String.Regex/index.js";
import * as Data_String_Regex_Flags from "../Data.String.Regex.Flags/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
import * as Data_Unfoldable from "../Data.Unfoldable/index.js";
import * as Parsing from "../Parsing/index.js";
import * as Parsing_String_Basic from "../Parsing.String.Basic/index.js";
import * as Partial_Unsafe from "../Partial.Unsafe/index.js";
import * as Restaumatic_Common_Translations_Keys from "../Restaumatic.Common.Translations.Keys/index.js";
import * as Restaumatic_Form_DynamicResult from "../Restaumatic.Form.DynamicResult/index.js";
import * as Restaumatic_Form_Final from "../Restaumatic.Form.Final/index.js";
import * as Restaumatic_I18n from "../Restaumatic.I18n/index.js";
var bindFinal = /* #__PURE__ */ Restaumatic_Form_Final.bindFinal();
var pure = /* #__PURE__ */ Control_Applicative.pure(Restaumatic_Form_DynamicResult.applicativeDynamicResult);
var mempty = /* #__PURE__ */ Data_Monoid.mempty(Data_String_Regex_Flags.monoidRegexFlags);
var mapFlipped = /* #__PURE__ */ Data_Functor.mapFlipped(Data_Maybe.functorMaybe);
var map = /* #__PURE__ */ Data_Functor.map(Restaumatic_Form_DynamicResult.functorDynamicResult);
var mwhen = /* #__PURE__ */ Data_Monoid_Extra.mwhen(Data_Monoid.monoidArray);
var map1 = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showString);
var munless = /* #__PURE__ */ Data_Monoid_Extra.munless(Data_Monoid.monoidArray);
var join = /* #__PURE__ */ Control_Bind.join(Data_Maybe.bindMaybe);
var mapFlipped1 = /* #__PURE__ */ Data_Functor.mapFlipped(Parsing.functorParserT);
var replicateA = /* #__PURE__ */ Data_Unfoldable.replicateA(Parsing.applicativeParserT)(Data_Unfoldable.unfoldableArray)(Data_Traversable.traversableArray);
var bindFlipped = /* #__PURE__ */ Control_Bind.bindFlipped(Data_Maybe.bindMaybe);
var traverse = /* #__PURE__ */ Data_Traversable.traverse(Data_Traversable.traversableArray)(Data_Maybe.applicativeMaybe);
var lift2 = /* #__PURE__ */ Control_Apply.lift2(Restaumatic_Form_DynamicResult.applyDynamicResult);
var mempty1 = /* #__PURE__ */ Data_Monoid.mempty(Data_Monoid.monoidArray);
var show1 = /* #__PURE__ */ Data_Show.show(Data_Show.showInt);
var length = /* #__PURE__ */ Data_Foldable.length(Data_Foldable.foldableArray)(Data_Semiring.semiringInt);
var whenJust = function (validate) {
    return function (value) {
        return bindFinal(value)(function (v) {
            if (v instanceof Data_Maybe.Nothing) {
                return pure([  ]);
            };
            if (v instanceof Data_Maybe.Just) {
                return validate(pure(v.value0));
            };
            throw new Error("Failed pattern match at Restaumatic.Form.Validation (line 140, column 5 - line 142, column 34): " + [ v.constructor.name ]);
        });
    };
};
var whenD = function (condD) {
    return function (validate) {
        return function (value) {
            return bindFinal(Restaumatic_Form_Final.liftDynamic(condD))(function (cond) {
                if (cond) {
                    return validate(value);
                };
                return pure([  ]);
            });
        };
    };
};
var testRx = function (rxS) {
    return function (s) {
        var rxMb = Data_Either.hush(Data_String_Regex.regex(rxS)(mempty));
        return Data_Maybe.fromMaybe(false)(mapFlipped(rxMb)(Data_Function.flip(Data_String_Regex.test)(s)));
    };
};
var predValidate = function (msg) {
    return function (pred) {
        return map(function (x) {
            return mwhen(pred(x))([ msg ]);
        });
    };
};
var postcodeValidate = /* #__PURE__ */ (function () {
    var errorMessage = Restaumatic_I18n.translationPending_("Kod pocztowy to np. 25-437");
    return predValidate(errorMessage)((function () {
        var $55 = Data_HeytingAlgebra.not(Data_HeytingAlgebra.heytingAlgebraBoolean);
        var $56 = testRx("^\\d{2}-\\d{3}$");
        return function ($57) {
            return $55($56($57));
        };
    })());
})();
var phoneNumber = /* #__PURE__ */ (function () {
    var remove = function (rx) {
        return function (inS) {
            return Data_Maybe.fromMaybe(inS)(map1(function (v) {
                return Data_String_Regex.replace(v)("")(inS);
            })(rx));
        };
    };
    var removePrefix = remove(Data_Either.hush(Data_String_Regex.regex("\\+\\d{1,3}")(Data_String_Regex_Flags.noFlags)));
    var phoneRE = Data_Either_Extra.fromRightWith(function (e) {
        return Partial_Unsafe.unsafeCrashWith(show(e));
    })(Data_String_Regex.regex("^\\+?[0-9 -]+$")(Data_String_Regex_Flags.noFlags));
    var nonDigitRE = Data_Either.hush(Data_String_Regex.regex("\\D")(Data_String_Regex_Flags.global));
    var empty = function ($58) {
        return Data_String_Common["null"](Data_String_Common.trim($58));
    };
    var doesPhoneMatchRegex = Data_String_Regex.test(phoneRE);
    var countDigits = function (s) {
        return Data_String_CodePoints.length(remove(nonDigitRE)(s));
    };
    var hasReasonableNumberOfDigits = function ($59) {
        return (function (n) {
            return n > 4 && n < 16;
        })(countDigits(removePrefix($59)));
    };
    return map(function (s) {
        return munless(empty(s))(munless(doesPhoneMatchRegex(s) && hasReasonableNumberOfDigits(s))([ Restaumatic_I18n.translate_(Restaumatic_Common_Translations_Keys.t.validations.invalid_phone) ]));
    });
})();
var parseTenDigits = function (s) {
    return join(Data_Either.hush(Parsing.runParser(s)(mapFlipped1(replicateA(10)(Parsing_String_Basic.digit))(function (digits) {
        return bindFlipped(Data_Array_NonEmpty.fromArray)(traverse(function ($60) {
            return Data_Int.fromString(Data_String_CodeUnits.singleton($60));
        })(digits));
    }))));
};
var number = /* #__PURE__ */ (function () {
    var numberRE = Data_Either_Extra.fromRightWith(function (e) {
        return Partial_Unsafe.unsafeCrashWith(show(e));
    })(Data_String_Regex.regex("^[0-9]+$")(Data_String_Regex_Flags.noFlags));
    var empty = function ($61) {
        return Data_String_Common["null"](Data_String_Common.trim($61));
    };
    var doesNumberMatchRegex = Data_String_Regex.test(numberRE);
    return map(function (s) {
        return munless(empty(s))(munless(doesNumberMatchRegex(s))([ Restaumatic_I18n.translate_(Restaumatic_Common_Translations_Keys.t.validations.invalid_number) ]));
    });
})();
var notNothing = /* #__PURE__ */ map(function (a) {
    return mwhen(Data_Maybe.isNothing(a))([ Restaumatic_I18n.translate_(Restaumatic_Common_Translations_Keys.t.form.errors.required) ]);
});
var nonEmptySet = /* #__PURE__ */ map(function (v) {
    return mwhen(Data_Set.isEmpty(v))([ Restaumatic_I18n.translate_(Restaumatic_Common_Translations_Keys.t.form.errors.required) ]);
});
var nonEmpty = function (dictEq) {
    var eq = Data_Eq.eq(dictEq);
    return function (dictMonoid) {
        var mempty2 = Data_Monoid.mempty(dictMonoid);
        return map(function (a) {
            return mwhen(eq(a)(mempty2))([ Restaumatic_I18n.translate_(Restaumatic_Common_Translations_Keys.t.form.errors.required) ]);
        });
    };
};
var lessThanJust = function (dictOrd) {
    var lessThan2 = Data_Ord.lessThan(dictOrd);
    return function (dictShow) {
        return function (msg) {
            return lift2(function (threshold) {
                return function (value) {
                    return Data_Maybe.maybe(mempty1)(function (t) {
                        return munless(lessThan2(value)(t))([ msg ]);
                    })(threshold);
                };
            });
        };
    };
};
var lessThan = function (dictOrd) {
    var lessThan2 = Data_Ord.lessThan(dictOrd);
    return function (dictShow) {
        return function (msg) {
            return lift2(function (threshold) {
                return function (value) {
                    return munless(lessThan2(value)(threshold))([ msg ]);
                };
            });
        };
    };
};
var inRange = function (range) {
    return map(function (a) {
        return mwhen(a < range.min || a > range.max)([ Restaumatic_I18n.translate(Restaumatic_Common_Translations_Keys.t.validations.invalid_range)({
            min: show1(range.min),
            max: show1(range.max)
        }) ]);
    });
};
var greaterThanJust = function (dictOrd) {
    var greaterThan2 = Data_Ord.greaterThan(dictOrd);
    return function (dictShow) {
        return function (msg) {
            return lift2(function (threshold) {
                return function (value) {
                    return Data_Maybe.maybe(mempty1)(function (t) {
                        return munless(greaterThan2(value)(t))([ msg ]);
                    })(threshold);
                };
            });
        };
    };
};
var greaterThan = function (dictOrd) {
    var greaterThan2 = Data_Ord.greaterThan(dictOrd);
    return function (dictShow) {
        return function (msg) {
            return lift2(function (threshold) {
                return function (value) {
                    return munless(greaterThan2(value)(threshold))([ msg ]);
                };
            });
        };
    };
};
var fullName = /* #__PURE__ */ (function () {
    var wordRE = Data_Either_Extra.fromRightWith(function (e) {
        return Partial_Unsafe.unsafeCrashWith(show(e));
    })(Data_String_Regex.regex("\\s+")(Data_String_Regex_Flags.noFlags));
    var words = Data_String_Regex.split(wordRE);
    var hasMin2Words = function (x) {
        return length(Data_Array.filter(function (v) {
            return v !== "";
        })(words(x))) >= 2;
    };
    var empty = function ($62) {
        return Data_String_Common["null"](Data_String_Common.trim($62));
    };
    return map(function (s) {
        return munless(empty(s))(munless(hasMin2Words(s))([ Restaumatic_I18n.translate_(Restaumatic_Common_Translations_Keys.t.validations.invalid_full_name) ]));
    });
})();
var email = /* #__PURE__ */ (function () {
    var empty = function ($63) {
        return Data_String_Common["null"](Data_String_Common.trim($63));
    };
    var emailRE = Data_Either_Extra.fromRightWith(function (e) {
        return Partial_Unsafe.unsafeCrashWith(show(e));
    })(Data_String_Regex.regex("^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~.-]+@[a-zA-Z0-9-]+(\\.[a-zA-Z0-9-]+)+$")(Data_String_Regex_Flags.noFlags));
    var doesEmailMatchRegex = Data_String_Regex.test(emailRE);
    return map(function (s) {
        return munless(empty(s))(munless(doesEmailMatchRegex(s))([ Restaumatic_I18n.translate_(Restaumatic_Common_Translations_Keys.t.validations.invalid_email) ]));
    });
})();
export {
    fullName,
    inRange,
    email,
    number,
    phoneNumber,
    nonEmpty,
    notNothing,
    postcodeValidate,
    predValidate,
    testRx,
    parseTenDigits,
    whenD,
    whenJust,
    greaterThan,
    greaterThanJust,
    lessThan,
    lessThanJust,
    nonEmptySet
};
